import { useDynamicEntity } from './useDynamicEntity';
import { useAuth } from './index';

const useWorkStatus = () => {
  const { user } = useAuth();
  const dynamicHook = useDynamicEntity({
    entityType: 'workStatus',
    gqlEntityKey: 'work_status',
    queryName: 'GET_WORK_STATUS_QUERY',
    createMutation: 'CREATE_WORK_STATUS_MUTATION',
    updateMutation: 'UPDATE_WORK_STATUS_MUTATION',
    deleteMutation: 'DELETE_WORK_STATUS_MUTATION',
    updateVariableName: 'set',
    transformData: (workStatus) => ({
      ...workStatus,
      company_name: workStatus.company?.name || `Company ${workStatus.company_id}`,
      name: workStatus.name,
      description: workStatus.description,
      status: workStatus.status ? 'active' : 'inactive',
      companyId: workStatus.company_id,
    }),
    transformFormData: (formData) => ({
      name: formData.name,
      description: formData.description || null,
      status: formData.status === 'active',
    }),
    customWhereCondition: user?.role === 'ROOT' ? {} : { company_id: { _eq: user?.companyId } },
  });
  return {
    ...dynamicHook,
    isRootUser: user?.role === 'ROOT',
  };
};

export { useWorkStatus }; 